import { useEffect, useState } from 'react';

import PlayIcon from '../icons/play.svg?react';

/**
 * The step's walkthrough, behind a cover of our own.
 *
 * YouTube's default poster is a frame of the video with its own chrome over it, which looks nothing
 * like the rest of the panel. Playing on demand also means a step nobody opens never loads YouTube.
 */
export function StepVideo({ embedUrl, title, isExpanded }: { embedUrl: string; title: string; isExpanded: boolean }) {
  const [isPlaying, setIsPlaying] = useState(false);

  // The row keeps its content mounted while collapsed so the height animates against something, and
  // a playing iframe in a zero-height box goes on talking out of sight. Closing the row stops it.
  useEffect(() => {
    if (!isExpanded) {
      setIsPlaying(false);
    }
  }, [isExpanded]);

  if (isPlaying) {
    return (
      <div className="relative mt-3 aspect-video w-full overflow-hidden rounded-lg">
        <iframe
          className="absolute inset-0 h-full w-full"
          src={`${embedUrl}?autoplay=1`}
          title={`${title} walkthrough`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => setIsPlaying(true)}
      // Deliberately not naming the step: the card already does, and repeating it here gives the
      // card two controls whose accessible names both contain the title.
      aria-label="Play walkthrough"
      className="relative mt-3 flex aspect-video w-full cursor-pointer items-center justify-center overflow-hidden rounded-lg border-0 bg-blue p-0"
    >
      <img src="/favicon.svg" alt="" aria-hidden className="absolute top-3 left-3 h-6 w-6" />
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-blue">
        <PlayIcon width={22} height={22} aria-hidden />
      </span>
    </button>
  );
}
